import axios from 'axios';

const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

const uploadHeaders = {
  'Content-Type': 'multipart/form-data',
  Accept: 'application/json',
};

const customFetch = (url, method, body = {}, isUpload = false) => {
  const options = {
    url,
    method,
    headers: isUpload ? uploadHeaders : headers,
  };

  if (method === 'GET' && body) {
    options.params = body;
  } else if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
    options.data = JSON.stringify(body);
  }
  return new Promise((resolve, reject) => {
    axios
      .request(options)
      .then((res) => resolve(res))
      .catch(({ response }) => {
        if (!response) {
          return reject({
            status: 'unknown',
            message: 'unknown error',
          });
        }
        if (response.status === 401) {
          window.location = '/login';
          return reject({
            statusCode: response.status,
            statusText: response.statusText,
            status: response.data.status,
            message: response.data.message,
          });
        }
        return reject({
          statusCode: response.status,
          statusText: response.statusText,
          status: response.data.status,
          message: response.data.message,
        });
      });
  });
};

export const get = (path) => customFetch(path, 'GET');
export const post = (path, body) => customFetch(path, 'POST', body);
export const put = (path, body) => customFetch(path, 'PUT', body);
export const remove = (path, body) => customFetch(path, 'DELETE', body);
export const upload = (path, body) => customFetch(path, 'post', body, true);
